import { useEffect, useState } from 'react';

import { addSeconds, differenceInSeconds } from 'date-fns';

export const useTimeoutTimer = (timeoutSeconds: number) => {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [dueDate, setDueDate] = useState<Date | 0>(0);

  let timer: ReturnType<typeof setTimeout>;

  const calculateTime = () => {
    const time = Math.max(differenceInSeconds(dueDate, Date.now()), 0);

    setSecondsLeft(time);

    if (time <= 0) {
      clearTimeout(timer);

      return;
    }

    timer = setTimeout(() => calculateTime(), 1000);
  };

  useEffect(() => {
    calculateTime();

    return () => {
      clearTimeout(timer);
    };
  }, [calculateTime, dueDate]);

  const restartTimer = () => {
    setDueDate(addSeconds(Date.now(), timeoutSeconds));
  };

  return {
    secondsLeft,
    restartTimer,
  };
};
